import React from 'react';
import { array, node, object, string } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { getCloudinaryBaseUrl } from '../../../util/cloudinary';
import { NamedLink, AspectRatioWrapper, PaginationLinks } from '../../../components';

import css from './SearchResultsPanel.module.css';

const cloudinaryBaseUrl = getCloudinaryBaseUrl();

const BrandCard = props => {
  const { brand } = props;
  const imagePath = `${cloudinaryBaseUrl}/listingFields/brand/${brand.id}.jpg`;

  return (
    <NamedLink
      className={css.brandCard}
      name="SearchPage"
      to={{ search: `?pub_brand=${brand.id}` }}
    >
      <AspectRatioWrapper
        className={css.brandCardWrapper}
        aspectBoxClassName={css.brandCardAspectBox}
        width={4}
        height={3}
      >
        <img className={css.brandCardImage} src={imagePath} alt={brand.name} />
      </AspectRatioWrapper>
    </NamedLink>
  );
};

const SearchResultsPanel = props => {
  const { className, rootClassName, brands, pagination, search } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchBrandsPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  return (
    <div className={classes}>
      <div className={css.brandCards}>
        {brands.map(b => (
          <BrandCard key={b.id} className={css.brandCard} brand={b} />
        ))}
        {props.children}
      </div>
      {paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  brands: [],
  pagination: null,
  rootClassName: null,
  search: null,
};

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  brands: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
};

export default SearchResultsPanel;
